export enum EventTabType {
  MAIN = 'main',
  SIDE = 'side',
}

export enum MAIN_TAB_STATUS {
  REWARD = 'reward',
  PARTICIPATE = 'participate',
  PROGRESS = 'progress',
  MAIN_EVENT = 'main-event',
}

export enum SUB_TAB_STATUS {
  // 참가 안내 서브 탭
  PARTICIPATE_ONLINE = 'participate-online',
  PARTICIPATE_OFFLINE = 'participate-offline',

  // 새틀라이트 서브 탭
  PROGRESS_MAIN = 'progress-main',
  PROGRESS_SIDE = 'progress-side',

  // 오프라인 이벤트 서브 탭
  MAIN_EVENT_MAIN = 'main',
  MAIN_EVENT_SIDE = 'side',
}

// 메인 탭별 서브탭 그룹화
export const TAB_MAPPING = {
  // 각 메인 탭에 속하는 서브탭 목록
  [MAIN_TAB_STATUS.PARTICIPATE]: [
    SUB_TAB_STATUS.PARTICIPATE_ONLINE,
    SUB_TAB_STATUS.PARTICIPATE_OFFLINE,
  ],
  [MAIN_TAB_STATUS.PROGRESS]: [SUB_TAB_STATUS.PROGRESS_MAIN, SUB_TAB_STATUS.PROGRESS_SIDE],
  [MAIN_TAB_STATUS.MAIN_EVENT]: [SUB_TAB_STATUS.MAIN_EVENT_MAIN, SUB_TAB_STATUS.MAIN_EVENT_SIDE],
};

export const PARTICIPATE_TAB_STATUS = {
  ONLINE: SUB_TAB_STATUS.PARTICIPATE_ONLINE,
  OFFLINE: SUB_TAB_STATUS.PARTICIPATE_OFFLINE,
};

export const PROGRESS_TAB_STATUS = {
  MAIN: SUB_TAB_STATUS.PROGRESS_MAIN,
  SIDE: SUB_TAB_STATUS.PROGRESS_SIDE,
};

export const MAIN_EVENT_TAB_STATUS = {
  MAIN: SUB_TAB_STATUS.MAIN_EVENT_MAIN,
  SIDE: SUB_TAB_STATUS.MAIN_EVENT_SIDE,
};
